





















import { Prop, Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { StatusName, CSSStyleOptions } from '@libs-uuif/shared/common-types';

@Component({
  components: {
    SwIcon,
  },
})
export default class FwStatusFlag extends SwExtendedVue {
  @Prop({ type: String, default: 'normal' })
  name: StatusName;

  @Prop({ type: Number, default: undefined })
  blockSize: number;

  @Prop({ type: Number, default: 16 })
  iconSize: number;

  @Prop({ type: Boolean, default: false })
  asBlock: boolean;

  @Prop({ type: String, default: 'status-unknown' })
  iconName: string;
  @Prop({ type: String, default: '#cccccc' })
  backgroundColor: string;
  @Prop({ type: String, default: '' })
  haStatus: string;

  get iconRotate() {
    if (this.name === 'up') { return 90; }
    if (this.name === 'down') { return -90; }
    return undefined;
  }

  get rootStyle(): CSSStyleOptions {
    const style: CSSStyleOptions = {};

    if (this.blockSize !== undefined) {
      style.width = `${this.blockSize}px`;
      style.height = `${this.blockSize}px`;
      if (this.blockSize > 24) {
        style.borderRadius = '3px';
      }
    }

    style.backgroundColor = this.backgroundColor;

    return style;
  }
}
